import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type ToastSeverity = "success" | "info" | "warning" | "error";

type Toast = {
    id: string;
    message: string;
    severity: ToastSeverity;
};

type NotificationsState = {
    queue: Toast[];
};

const initialState: NotificationsState = {
    queue: [],
};

const notificationsSlice = createSlice({
    name: "notifications",
    initialState,
    reducers: {
        showToast: (state, action: PayloadAction<{ message: string; severity?: ToastSeverity }>) => {
            state.queue.push({
                id: crypto.randomUUID(),
                message: action.payload.message,
                severity: action.payload.severity ?? "info",
            });
        },
        dismissToast: (state) => {
            state.queue.shift();
        },
    },
});

export const { showToast, dismissToast } = notificationsSlice.actions;
export default notificationsSlice.reducer;
